import { render, staticRenderFns } from "./CulturePriceList.vue?vue&type=template&id=8e20f0b8"
import script from "./CulturePriceList.vue?vue&type=script&lang=js"
export * from "./CulturePriceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports